import styled from '@emotion/styled'

import { ItemOptions } from './GridList'

type GridItemProps = Omit<ItemOptions, 'truncateValue'>

export const GridListWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
`

export const GridItem = styled.li<GridItemProps>`
  ${({ containerWidth, itemPerRow }) => {
    if (itemPerRow) {
      return `
        width: 100%;

        &:not(:first-of-type) {
          margin-top: 28px;
        }
      `
    }

    if (containerWidth >= 800) {
      return `
        width: 20%;
        margin-right: 6%;

        &:nth-of-type(4n) {
          margin-right: 0;
        }
        &:nth-of-type(n + 5) {
          margin-top: 28px;
        }
      `
    }

    return `
      width: 44%;

      &:nth-of-type(2n) {
        margin-left: 12%;
      }
      &:nth-of-type(n + 3) {
        margin-top: 28px;
      }
    `
  }};
`
